<template>
  <div>
    <Contact />
    <br />
    <br />
    <br />
    <br />
    <Footer v-if="contactList != ''" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Contact from "../components/Contact";
import Footer from "../components/Footer.vue";
export default {
  components: {
    Contact,
    Footer,
  },
  computed: {
    ...mapGetters("contactStore", ["contactList"]),
  },
};
</script>

<style lang="scss" scoped></style>
